import {
  createMeetingMinutes$,
  deleteMeetingMinutes$,
  getMeetingMinutes$,
  updateMeetingMinutes$
} from "../services/projects";
import {networkError} from "./ui";
import {extractSubview} from "./view";

export const ADD_MEETING_MINUTES = 'ADD_MEETING_MINUTES';
export const addMeetingMinutes = (list) => ({type: ADD_MEETING_MINUTES, payload: list});
export const API_GET_MEETING_MINUTES_MULTIPLE = 'API_GET_MEETING_MINUTES_MULTIPLE';
export const getMeetingMinutesMultiple = (projectId, offset) => ({type: API_GET_MEETING_MINUTES_MULTIPLE, payload: {projectId, offset}});
export const API_GET_MEETING_MINUTES_MULTIPLE_DONE = 'API_GET_MEETING_MINUTES_MULTIPLE_DONE';
export const getMeetingMinutesMultipleDone = (response) => ({type: API_GET_MEETING_MINUTES_MULTIPLE_DONE, payload: response});
export const API_GET_MEETING_MINUTES = 'API_GET_MEETING_MINUTES';
export const getMeetingMinutes = (projectId, id) => ({type: API_GET_MEETING_MINUTES, payload: {projectId, id}});
export const API_GET_MEETING_MINUTES_DONE = 'API_GET_MEETING_MINUTES_DONE';
export const getMeetingMinutesDone = (response, callback) => ({ type: API_GET_MEETING_MINUTES_DONE, payload: { response, callback } });

export const createMeetingMinutes = (projectId, meetingMinutes, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createMeetingMinutes$({ projectId, document: meetingMinutes }).toPromise();
    ({ response, status } = await getMeetingMinutes$({ id: response, projectId }).toPromise());
    dispatch(getMeetingMinutesDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10152-'+error.status}));
  }
};

export const deleteMeetingMinutes = (projectId, meetingMinutesId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteMeetingMinutes$({ projectId, subId: meetingMinutesId }).toPromise();
    dispatch(extractSubview([meetingMinutesId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10153-'+error.status}));
  }
};

export const updateMeetingMinutes = (projectId, meetingMinutes) => async (dispatch, getState) => {
  try {
    let meetingMinutesId = meetingMinutes.id;
    let { response, status } = await updateMeetingMinutes$({ projectId, subId: meetingMinutesId, document: meetingMinutes }).toPromise();
    let { response: response2, status: status2 } = await getMeetingMinutes$({ projectId, id: meetingMinutesId }).toPromise();
    dispatch(getMeetingMinutesDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10154-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/meetingMinutes.js